//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationFileController_create,
  Response$AdminObligationFileController_create$Status$201,
  ResponseContentType$AdminObligationFileController_create,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationFileController_create = () =>
  useApiClientMutation<
    Params$AdminObligationFileController_create,
    Response$AdminObligationFileController_create$Status$201[ResponseContentType$AdminObligationFileController_create]
  >({ method: 'AdminObligationFileController_create' });
